<form [formGroup]="searchForm" class="form-horizontal">
  <div class="form-group">
    <label class="col-sm-2 control-label" for="query">
      Artikel Gruppen Suche:
    </label>
    <div class="col-sm-10">
      <input class="form-control" type="text" id="query" formControlName="searchQuery">
    </div>
  </div>
</form>

<div class="row">
  <div class="col-sm-12">
    &nbsp;
  </div>
</div>
@if (showGroups()) {
  <div class="whitelist">
    @if (currentGroup) {
      <div class="whitelist-item selected" (click)="toggleSelectGroup(currentGroup)">
        <i class="fa fa-check"></i> {{currentGroup.group_id}} {{currentGroup.name}}
      </div>
    }
    @if (!currentGroup) {
      @for (group of groups; track group) {
        <div class="whitelist-item" [ngClass]="isGroupSelected(group)? 'selected' : ''" (click)="toggleSelectGroup(group)"
          >
          <i class="fa fa-check" [ngClass]="isGroupSelected(group)?'':'hide-icon'"></i> {{group.group_id}} {{group.name}}
        </div>
      }
    }
  </div>
}
@if (showArticles()) {
  <div class="whitelist">
    @if (currentArticle) {
      <div class="whitelist-item selected" (click)="toggleSelectArticle(currentArticle)">
        <i class="fa fa-check"></i> {{currentArticle.article_id}} {{currentArticle.name}}
      </div>
    }
    @if (!currentArticle) {
      @for (article of articles; track article) {
        <div class="whitelist-item" [ngClass]="isArticleSelected(article)? 'selected' : ''"
          (click)="toggleSelectArticle(article)">
          <i class="fa fa-check" [ngClass]="isArticleSelected(article)?'':'hide-icon'"></i> {{article.article_id}}
          {{article.name}}
        </div>
      }
    }
  </div>
}
@if (showVariations()) {
  <div class="whitelist">
    @if (currentVariation) {
      <div class="whitelist-item selected" (click)="toggleSelectVariation(currentVariation)">
        <i class="fa fa-check"></i> {{currentVariation.variation_id}} {{currentVariation.vendor_article_id}}
      </div>
    }
    @if (!currentVariation) {
      @for (variation of variations; track variation) {
        <div class="whitelist-item" [ngClass]="isVariationSelected(variation)? 'selected' : ''"
          (click)="toggleSelectVariation(variation)">
          <i class="fa fa-check" [ngClass]="isVariationSelected(variation)?'':'hide-icon'"></i> {{variation.variation_id}}
          {{variation.vendor_article_id}}
        </div>
      }
    }
  </div>
}
@if (!!searchResults && !currentVariation) {
  @if (searchResults.length === 0) {
    Keine Artikel mit diesen Eigenschaften gefunden
  }
  @if (searchResults.length > 0) {
    <table class="whitetable">
      <thead>
        <tr>
          <th>Nr.</th>
          <th>Gruppe</th>
          @if (level > 1) {
            <th>Artikel</th>
          }
          @if (level > 2) {
            <th>Art. Nr. Lieferant</th>
          }
          @if (level > 2) {
            <th>Passende Felder</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (result of searchResults; track result) {
          <tr (click)="toggleSelectResult(result)">
            <td>{{result.string_id}}</td>
            <td>{{result.group_name}}</td>
            @if (level > 1) {
              <td>{{result.article_name}}</td>
            }
            @if (level > 2) {
              <td>{{result.vendor_article_id}}</td>
            }
            @if (level > 2) {
              <td>{{result.matching_fields ? stringHelper.concat(result.matching_fields) : ''}}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  }
}
